import { FC } from 'react';
import type { TagGroup, TagGroupSearchApi } from 'src/common/types/common/TagGroups';
import Typography from 'src/common/components/Typography';
import Pill from 'src/common/components/dockyard/Pill';
import styles from './TagGroupPills.module.scss';

type PillColor = 'blue' | 'green' | 'gray' | 'red' | 'ivory';
export type TagGroupPillsProps = {
  tagGroup: TagGroupSearchApi;
  withGroupTitle?: boolean;
  /** Override default chip color */
  pillColor?: PillColor;
};

const defaultPillColor: Record<TagGroup['name'], PillColor> = {
  Experiences: 'gray',
  Accessories: 'green',
  'Leisure & Entertainment Equipment': 'blue',
  'Operating Equipment': 'gray',
  'Safety Equipment': 'red',
  'Guest Amenities': 'ivory',
};

/** A single category */
const TagGroupPills: FC<TagGroupPillsProps> = ({
  tagGroup,
  withGroupTitle = true,
  pillColor,
}) => (
  <div className={styles.root}>
    {withGroupTitle && (
      <Typography
        type="h3"
        size="body-m"
        weight="semibold"
      >
        {tagGroup.name}
      </Typography>
    )}
    <div className={styles.pills}>
      {tagGroup.tags.map((tag) => (
        <Pill key={tag.name} color={pillColor ?? defaultPillColor[tagGroup.name]}>
          {tag.name}
          {tag.units && ` (${tag.units})`}
        </Pill>
      ))}
    </div>
  </div>
);

export default TagGroupPills;
